import { ensureHttpsUrl } from './ensure-https-url';

const VIEWABLE_MIME_TYPES = new Set([
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/svg+xml',
  'text/html',
  'text/plain',
  'text/markdown',
]);

export function getUrlHostname(url: string): string | null {
  const normalized = ensureHttpsUrl(url);
  if (!normalized) {
    return null;
  }
  try {
    return new URL(normalized).hostname || null;
  } catch {
    return null;
  }
}

export function isViewableInBrowser(mimeType: string | null, url: string | null): boolean {
  if (url) {
    return true;
  }
  if (!mimeType) {
    return false;
  }
  return VIEWABLE_MIME_TYPES.has(mimeType);
}

export function getAdjacentResourceIds(
  orderedIds: string[],
  currentId: string | undefined,
): { previousId: string | null; nextId: string | null } {
  if (!currentId || orderedIds.length < 2) {
    return { previousId: null, nextId: null };
  }
  const index = orderedIds.indexOf(currentId);
  if (index === -1) {
    return { previousId: null, nextId: null };
  }
  const previousId = orderedIds[(index - 1 + orderedIds.length) % orderedIds.length];
  const nextId = orderedIds[(index + 1) % orderedIds.length];
  return { previousId, nextId };
}

export function isLikelyDirectImageUrl(url: string): boolean {
  try {
    const pathname = new URL(url).pathname.toLowerCase();
    return /\.(jpg|jpeg|png|gif|webp|svg|avif|bmp)(\?|#|$)/i.test(pathname);
  } catch {
    return false;
  }
}

export function resourceDisplaysImageThumbnail(resource: {
  mimeType: string | null;
  url: string | null;
  s3Key: string | null;
}): boolean {
  if (resource.mimeType?.startsWith('image/')) {
    return true;
  }
  if (resource.url && !resource.s3Key && isLikelyDirectImageUrl(resource.url)) {
    return true;
  }
  return false;
}
